import { Inject, Pipe, PipeTransform } from '@angular/core';
import { SecureImage } from '@miq/utils';
import { ReportRecord } from '../../models/report.model';
import { NavigationRouteFunctionPPTSettings } from '../../models/template.model';
import { TEMPLATE_CONFIGURATIONS } from '../templates/template-display-fn.const';
import { CbreLogger, CbreLoggerToken } from '@cbre/logger';

/**
 * Get **field route function** from the template configurations, based on the
 * combination of the template id and the field id. If found, it executes the
 * function, passing the provided record.
 */
@Pipe({
  name: 'reportFieldRouteFn',
  standalone: false,
})
export class ReportFieldRouteFnPipe implements PipeTransform {
  constructor(@Inject(CbreLoggerToken) private readonly logger: CbreLogger) {}
  transform(
    record: { [attr: string]: any },
    settings: NavigationRouteFunctionPPTSettings
  ): string | string[] | SecureImage {
    const { fieldsDisplayFunctions } = TEMPLATE_CONFIGURATIONS[settings.templateId];
    const displayFnConfiguration = fieldsDisplayFunctions[settings.field.id];

    if (displayFnConfiguration == null || displayFnConfiguration.routeFn == null) {
      this.logger.warn(
        `No display fn config or route function for template with id: ${settings.templateId} or for field with id: ${settings.field.id}`
      );
      return [];
    }

    return displayFnConfiguration.routeFn(record as ReportRecord, settings);
  }
}
